/*
 * Match URL condition
 * @module
 */
var matchUrl = require('core/plugins/helpers/match_url');

/**
 * @type ConditionMatcher
 */
module.exports = {
  // specify the fields needed
  fieldsNeeded: [
    'url',
  ],

  /**
   * @param {Object} value
   * @param {Condition} cond
   * @return {boolean}
   */
  match: function(value:any, cond:Condition): boolean {
    return matchUrl(value.url, cond);
  },
};
